import { TextItem, DropArea } from '@lernetz/lernfragen/components/drag-and-drop-quiz';


export class DraggableTextItemViewModel extends TextItem {
    public readonly correctDropArea: DropArea;            
    public constructor(initialState, correctDropArea: DropArea) {
        super(initialState);
        this.correctDropArea = correctDropArea;
    }
}